import React from 'react';
import { Link } from 'react-router-dom';

const Landing = () => {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center vh-100'>
      <div className='fs-1'>
        Bienvenue Dans Notre Platforme Energy Monitoring
      </div>
      <Link
        className='bg-dark text-light py-2 px-4 text-decoration-none mt-3 fw-bold fs-5'
        to='/login'
      >
        Login
      </Link>
    </div>
  );
};

export default Landing;
